// Meeting type options shared by the Squadcast and Velvet Meetings schedulers.
// Order matters: Content Meeting is first/default. Only 'content' triggers the
// automatic content-generation/subscription workflow after the meeting; the
// others still record and become a source, but skip that workflow.
//
// `description` is client-facing copy that is shown read-only in the
// Description field once a meeting type is selected.
export const MEETING_TYPES = [
  {
    value: 'content',
    label: 'Content Meeting',
    description: 'Use this for content-production calls. Velvet will automatically turn this recording into content once the meeting ends.',
  },
  {
    value: 'strategy',
    label: 'Strategy Meeting',
    description: "Use this for strategy and planning conversations. The meeting will still be recorded and saved, but Velvet won't automatically generate content from it.",
  },
  {
    value: 'checkin',
    label: 'Check-in / Review Meeting',
    description: "Use this for check-ins or reviews, like going over your SEO performance. The meeting will still be recorded and saved, but Velvet won't automatically generate content from it.",
  },
];

export const DEFAULT_MEETING_TYPE = MEETING_TYPES[0].value;

export const getMeetingTypeLabel = (value) =>
  MEETING_TYPES.find(t => t.value === value)?.label || MEETING_TYPES[0].label;

export const getMeetingTypeDescription = (value) =>
  MEETING_TYPES.find(t => t.value === value)?.description || MEETING_TYPES[0].description;
